import '../src/polyfills.js'
import { createApp, h } from 'vue'
import { injectToasted } from '../src/utils/vue-toasted/inject_toasted'
import DocumentRiskTags from '../src/vue_shared/components/document_risk_tags.vue'
import { updateDocReviewStatus } from '../src/pages/admin/store/document_dashboard_model'
import '../styles/document_risk_tags.scss'
import NrSentry from '../src/utils/nr_sentry'

document.addEventListener('DOMContentLoaded', () => {
  const tagsEl = document.getElementById(
    'document-header-risk-tags'
  ) as HTMLElement

  if (!tagsEl) return

  const { scanId, manage, reviewStatus, severity } = tagsEl.dataset

  // eslint-disable-next-line no-new
  const app = createApp({
    data: function () {
      return {
        scanId: +scanId,
        manage: manage === 'true',
        reviewStatus,
        severity
      }
    },
    render() {
      return h(DocumentRiskTags, {
        scanId: this.scanId,
        manage: this.manage,
        reviewStatus: this.reviewStatus,
        severity: this.severity,
        onOnReviewStatusClick: this.handleOnReviewStatusClick
      })
    },
    methods: {
      handleOnReviewStatusClick() {
        updateDocReviewStatus({
          id: this.scanId,
          review_status:
            this.reviewStatus !== 'needs_review' ? 'needs_review' : 'reviewed'
        })
          .then(({ review_status: reviewStatus }) => {
            this.reviewStatus = reviewStatus
            this.$toasted.success('Successfully updated the review status.')
          })
          .catch((error) => {
            this.$toasted.error(
              'There was an error updating the review status.'
            )
            NrSentry.captureError(error)
          })
      }
    }
  })

  injectToasted(app)

  app.mount(tagsEl)
})
